export const EMPENHOS_EM_LIQUIDACAO = 'EMPENHOS_EM_LIQUIDACAO';
export const EMPENHOS_EM_LIQUIDACAO_START = 'EMPENHOS_EM_LIQUIDACAO_START';
export const EMPENHOS_EM_LIQUIDACAO_SUCCESS = 'EMPENHOS_EM_LIQUIDACAO_SUCCESS';
export const EMPENHOS_EM_LIQUIDACAO_ERROR = 'EMPENHOS_EM_LIQUIDACAO_ERROR';
